import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectImageUploadCommand, ProjectImageUploadResponse } from '../entity/ProjectTypes';

export class UploadProjectImageUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectImageUploadCommand): Promise<ProjectImageUploadResponse> {
    return this.repository.uploadProjectImage(command);
  }
}
